// assets/mwc-core.js

window.MWC = (function () {
function getEdge() {
  var env =
    window.mwcConfig && window.mwcConfig.environment === "development"
      ? "development"
      : "production";

  var prefix = env === "development" ? "dev-edge." : "edge.";
  return "https://" + prefix + window.location.host;
}

  async function request(url, options) {
    var config = options || {};
    var headers = config.headers || {};
    var finalHeaders = {
      "Content-Type": "application/json"
    };

    Object.keys(headers).forEach(function (key) {
      finalHeaders[key] = headers[key];
    });

    var res = await fetch(url, {
      credentials: "include",
      ...config,
      headers: finalHeaders
    });

    if (!res.ok) {
      var text = "";
      try {
        text = await res.text();
      } catch (e) {}
      throw new Error(text || "Request failed");
    }

    return res.json();
  }

  async function me() {
    return request(getEdge() + "/me");
  }

async function getMyWatches() {
  return request(
    getEdge() + "/my-watches"
  );
}

async function getWatch(payload) {
  var params = new URLSearchParams(payload || {});
  return request(getEdge() + "/watch?" + params.toString(), {
    method: "GET"
  });
}

async function getRecommendations(payload) {
  var params = new URLSearchParams(payload || {});

  return request(getEdge() + "/recommendations?" + params.toString(), {
    method: "GET"
  });
}



    async function updateWatch(payload) {
    return request(getEdge() + "/watch", {
      method: "PATCH",
      body: JSON.stringify(payload)
    });
  }

async function uploadWatchPhotos(payload) {
  var formData = new FormData();

  formData.append("id", payload.id);

  formData.append("file", payload.files[0]);

    console.log("UPLOAD URL:", getEdge() + "/upload-photo");
    return fetch(getEdge() + "/upload-photo", {
    method: "POST",
    credentials: "include",
    body: formData
  }).then(function (res) {
    if (!res.ok) {
      return res.text().then(function (text) {
        throw new Error(text || "Upload failed");
      });
    }

    return res.json();
  });
}


  async function deleteWatch(payload) {
    return request(getEdge() + "/watch", {
      method: "DELETE",
      body: JSON.stringify(payload)
    });
  }

  return {
    me: me,
    request: request,
    getMyWatches: getMyWatches,
    getWatch: getWatch,
    getRecommendations: getRecommendations,
    updateWatch: updateWatch,
    uploadWatchPhotos: uploadWatchPhotos,
    deleteWatch: deleteWatch
  };
})();